import React from "react";

// External
import styled from "styled-components";
import { Element } from "react-scroll";

// Internal
import SplashText from "../../components/SplashText";
import { breakpoints, fontFamily, spacing } from "../../../theme";

// Styles
const Section = styled(Element)`
  // height: 100vh;
  padding: 20px 0px 60px;
  background-color: ${props => (props.bgColor ? props.bgColor : "#ffffff")};

  @media only screen and (min-width: ${breakpoints.tablet}) {
    padding: 70px 0 150px;
  }
`;

const Heading = styled.h1`
  font-family: ${fontFamily.extraBold};
  font-size: 26px;
  line-height: 120%;
  letter-spacing: -1%;
  text-align: center;
  @media only screen and (min-width: ${breakpoints.tablet}) {
    font-size: 52px;
  }
  @media only screen and (min-width: ${breakpoints.desktop}) {
    font-size: 60px;
  }
`;

const SkillCardList = styled.div`
  margin-top: ${spacing(9)};
  @media only screen and (min-width: ${breakpoints.tablet}) {
    display: flex;
    justify-content: space-evenly;
    margin-top: 120px;
  }
`;
const SkillCard = styled.div`
  background: ${props => props.bgColor};
  border-radius: 24px;
  width: 80%;
  margin: 0 auto 12px;
  padding: 27px;
  // width: 335px;
  // height: 237px;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    padding: 70px 42px 112px;
    width: 27%;
    max-width: 503px;
    margin: 0;
  }
`;
const SkillCardIcon = styled.div`
  padding: 16px 0;

  & svg {
    transform: scale(1.5);
    padding-left: 16px;
    margin-bottom: 32px;
  }
`;
const SkillCardHeading = styled.div`
  margin: 4px 0;
  font-size: 20px;
  font-family: ${fontFamily.bold};
  @media only screen and (min-width: ${breakpoints.tablet}) {
    font-size: 36px;
  }
`;
const SkillCardDescription = styled.div`
  margin-bottom: 12px;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    font-size: 20px;
    width: 98%;
    margin-top: 8px;
  }
`;

const SkillsSection = () => {
  return (
    <Section name="skills" as="section">
      <Heading>
        <SplashText variant="peach">Skills</SplashText>
      </Heading>
      <SkillCardList>
        <SkillCard bgColor="#FFF3F0">
          <SkillCardIcon>
            <svg
              width="70"
              height="64"
              viewBox="0 0 70 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M70 32.0929C70 27.4554 64.1929 23.06 55.2883 20.3358C57.3446 11.262 56.4317 4.04038 52.4067 1.72746C51.4314 1.18123 50.3276 0.906278 49.21 0.931209V4.11038C49.8662 4.11038 50.3942 4.24163 50.8375 4.48371C52.7771 5.59788 53.62 9.83288 52.9637 15.2841C52.8063 16.6258 52.5496 18.0375 52.2346 19.4783C49.2527 18.7597 46.2263 18.2404 43.1754 17.9237C41.3579 15.4162 39.375 13.0329 37.24 10.7895C41.8921 6.46704 46.2583 4.09871 49.2275 4.09871V0.916626C45.3017 0.916626 40.1654 3.71371 34.9708 8.56413C29.7792 3.74579 24.64 0.974959 20.7171 0.974959V4.15413C23.6717 4.15413 28.0525 6.51079 32.7046 10.8041C30.7067 12.9041 28.7088 15.2841 26.81 17.9237C23.7528 18.2369 20.721 18.7612 17.7362 19.4929C17.4067 18.0666 17.1646 16.6841 16.9925 15.357C16.3217 9.90288 17.15 5.66788 19.0779 4.54204C19.5038 4.28538 20.0608 4.16871 20.7171 4.16871V0.989543C19.5213 0.989543 18.4333 1.24621 17.4942 1.78579C13.4838 4.09871 12.5854 11.3029 14.6533 20.3504C5.77792 23.092 0 27.47 0 32.0929C0 36.7304 5.80708 41.1258 14.7117 43.847C12.6554 52.9237 13.5683 60.1454 17.5933 62.4554C18.5208 62.9979 19.6058 63.2545 20.8017 63.2545C24.7275 63.2545 29.8638 60.4575 35.0583 55.607C40.25 60.4283 45.3862 63.1962 49.3121 63.1962C50.4382 63.22 51.5504 62.9442 52.535 62.397C56.5454 60.087 57.4438 52.8829 55.3758 43.8354C64.2221 41.1112 70 36.7158 70 32.0929ZM51.4208 22.5758C50.8666 24.4829 50.2243 26.3632 49.4958 28.2108C48.3034 25.8913 46.9941 23.6339 45.5729 21.447C47.6 21.7475 49.5542 22.1179 51.4238 22.5758H51.4208ZM44.8875 37.7716C43.7763 39.6966 42.6329 41.5254 41.4488 43.2229C37.1678 43.6002 32.8622 43.6051 28.5804 43.2375C26.1244 39.7292 23.9766 36.0151 22.1608 32.1366C23.9738 28.249 26.1125 24.5218 28.5542 20.995C32.8341 20.6169 37.1387 20.611 41.4196 20.9775C42.6038 22.675 43.7617 24.4891 44.8729 26.4025C45.9579 28.2691 46.9438 30.165 47.8421 32.0783C46.9338 34.0148 45.9481 35.9141 44.8875 37.7716ZM49.4958 35.9166C50.2658 37.827 50.925 39.7404 51.4646 41.5954C49.5979 42.0533 47.6263 42.4383 45.5875 42.7358C47.0028 40.5291 48.3072 38.2532 49.4958 35.9166ZM35.0292 51.1416C33.7021 49.7708 32.375 48.2454 31.0625 46.5741C32.3458 46.6325 33.6583 46.6762 34.9854 46.6762C36.3271 46.6762 37.6542 46.647 38.9521 46.5741C37.6688 48.2454 36.3417 49.7708 35.0292 51.1416ZM24.4125 42.7358C22.4459 42.4508 20.4936 42.0752 18.5617 41.61C19.0896 39.7695 19.7458 37.8708 20.4867 35.975C21.0729 37.1125 21.6883 38.2558 22.3592 39.3991C23.03 40.5395 23.7125 41.6537 24.4125 42.7358ZM34.9562 13.0441C36.2833 14.415 37.6104 15.9404 38.9229 17.6116C37.6396 17.5533 36.3271 17.5095 35 17.5095C33.6583 17.5095 32.3313 17.5387 31.0333 17.6116C32.3167 15.9404 33.6437 14.415 34.9562 13.0441ZM24.3979 21.45C22.983 23.6518 21.6786 25.9229 20.4896 28.2545C19.7406 26.3951 19.0836 24.4998 18.5208 22.5758C20.3875 22.1325 22.3592 21.7475 24.3979 21.45ZM11.4858 39.3116C6.43417 37.1591 3.1675 34.3329 3.1675 32.0929C3.1675 29.8529 6.43417 27.012 11.4858 24.8741C12.7108 24.3462 14.0525 23.8737 15.4379 23.4333C16.2517 26.2275 17.3221 29.1383 18.6463 32.122C17.3961 34.9284 16.3388 37.8168 15.4817 40.767C14.1267 40.3475 12.7932 39.8618 11.4858 39.3116ZM19.1625 59.6991C17.2229 58.5908 16.38 54.35 17.0363 48.9016C17.1938 47.56 17.4504 46.1454 17.7654 44.7045C20.5596 45.39 23.6133 45.9179 26.8246 46.262C28.6422 48.7695 30.6251 51.1528 32.76 53.3962C28.1079 57.7187 23.7417 60.087 20.7725 60.087C20.2123 60.0932 19.6593 59.9609 19.1625 59.702V59.6991ZM53.0075 48.8287C53.6783 54.28 52.85 58.5179 50.9221 59.6437C50.4963 59.9004 49.9392 60.0141 49.2829 60.0141C46.3283 60.0141 41.9475 57.6604 37.2954 53.3641C39.2933 51.27 41.2912 48.887 43.19 46.2475C46.2472 45.9343 49.279 45.41 52.2638 44.6783C52.5933 46.1191 52.8471 47.5016 53.0075 48.8287ZM58.4996 39.3116C57.2746 39.8395 55.9329 40.312 54.5475 40.7525C53.6753 37.7871 52.6034 34.8842 51.3392 32.0637C52.6517 29.0975 53.7046 26.2012 54.5038 23.4187C55.9183 23.8591 57.2571 24.3462 58.5142 24.8741C63.5658 27.0266 66.8325 29.8529 66.8325 32.0929C66.8179 34.3329 63.5512 37.1737 58.4996 39.3116Z"
                fill="black"
              />
              <path
                d="M34.9826 38.6143C36.7123 38.6143 38.3711 37.9272 39.5941 36.7041C40.8172 35.4811 41.5043 33.8222 41.5043 32.0926C41.5043 30.3629 40.8172 28.7041 39.5941 27.4811C38.3711 26.258 36.7123 25.5709 34.9826 25.5709C33.253 25.5709 31.5941 26.258 30.3711 27.4811C29.148 28.7041 28.4609 30.3629 28.4609 32.0926C28.4609 33.8222 29.148 35.4811 30.3711 36.7041C31.5941 37.9272 33.253 38.6143 34.9826 38.6143Z"
                fill="black"
              />
            </svg>
          </SkillCardIcon>
          <SkillCardHeading>Frontend web development</SkillCardHeading>
          <SkillCardDescription>
            React, Javascript, Typescript, Gatsby, Next.JS, GraphQl, Apollo,
            HTML, CSS, Styled Components, Redux, Stripe
          </SkillCardDescription>
        </SkillCard>
        <SkillCard bgColor="#F2F9F5">
          <SkillCardIcon>
            <svg
              width="85"
              height="85"
              viewBox="0 0 85 85"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.625 74.375H24.7917L70.8333 28.3333C72.7119 26.4547 73.7673 23.9068 73.7673 21.25C73.7673 18.5932 72.7119 16.0453 70.8333 14.1667C68.9547 12.2881 66.4068 11.2327 63.75 11.2327C61.0932 11.2327 58.5453 12.2881 56.6667 14.1667L10.625 60.2083V74.375Z"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M51.3516 19.4788L65.5182 33.6454"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M42.5 28.3333L24.7917 10.625L10.625 24.7917L28.3333 42.5"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M24.7891 28.3337L19.4766 33.6462"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M56.6667 42.5L74.375 60.2083L60.2083 74.375L42.5 56.6667"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M56.6641 60.2087L51.3516 65.5212"
                stroke="black"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </SkillCardIcon>
          <SkillCardHeading>UI/UX Design</SkillCardHeading>
          <SkillCardDescription>
            Figma, Framer Motion, Photoshop, Illustrator
          </SkillCardDescription>
        </SkillCard>
      </SkillCardList>
    </Section>
  );
};

export default SkillsSection;
